import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import router from './router';
import App from './App';
import store, { i18n } from './vuex';
import packageJson from '../package.json';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
// Sentry Error Logging
const sentryKey = window.$config.sentryKey;
if (sentryKey && window.location.hostname !== 'localhost') {
	Sentry.init({
		dsn: sentryKey,
		release: packageJson.version,
		environment: window.$config.environment,
		integrations: [new Integrations.Vue({ Vue })]
	});
}
Vue.use(BootstrapVue);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
	i18n,
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
});
